// extracted by mini-css-extract-plugin
module.exports = {"visibleContent":"patientsManagement_visibleContent__Vp53v"};